import { createScreenStyles } from '../../theme/styles';
import { OPERATIONS_API_BASE } from '../../config/api';
import React, { useState, useEffect } from "react";
import {
  View,
  ScrollView,
  Text,
  StyleSheet,
  TextInput,
  Image,
  TouchableHighlight,
  Dimensions,
  Platform
} from "react-native";
import RadioForm, {
  RadioButton,
  RadioButtonInput,
  RadioButtonLabel,
} from "react-native-simple-radio-button";
import CurrencyInput from 'react-native-currency-input';
import { Ionicons } from '@expo/vector-icons';

const screenWidth = Math.round(Dimensions.get("window").width);
const screenHeight = Math.round(Dimensions.get("window").height);

export function isIphoneX() {
  return Platform.OS === "ios" && screenHeight >= 812;
}

export function isAndroid() {
  return Platform.OS !== "ios";
}

export default function despesa_item({ route, navigation }) {
  const { despesaId, setDespesaId } = route.params;
  const [loading, setLoading] = useState(false);
  const [descr, setDescr] = useState("");
  const [valor, setValor] = useState(null);
  const [foto, setFoto] = useState(null);
  const [categoria, setCategoria] = useState("");
  const [categoriaText, setCategoriaText] = useState("");
  const [radio_props, setRadio_props] = useState([]);
  const [fotoSeq, setFotoSeq] = useState(null);

  var routeId = route.params.id;
  var status = route.params.status;

  async function loadRadio() {
    const response = await fetch(`${OPERATIONS_API_BASE}/categoriadespesa/`);
    const data = await response.json();
    const objRadio = [];
    data.map((categoria, indexe) => {
      objRadio.push({ label: categoria.categoria, value: indexe });
    });
    setRadio_props(objRadio);
  }

  async function load() {
    if (!routeId) {
      setFotoSeq(1);
      setLoading(false);
      return;
    }

    const response = await fetch(`${OPERATIONS_API_BASE}/despesaItem/` + routeId);
    const data = await response.json();
    setValor(data[0].valor);
    setDescr(data[0].descr);
    if (foto == null && data[0].foto != null) {
      setFoto(data[0].foto);
    }
    if (data[0].fotoSeq === null) {
      setFotoSeq(1);
    } else {
      setFotoSeq(data[0].fotoSeq);
    }
    setCategoria(data[0].categoria);
    setCategoriaText(data[0].categoriaText);
    setLoading(false);
  }

  async function loadFoto(URL) {
    setFoto(URL);
  }

  async function save() {
    if (categoria === "") {
      alert("Insira a categoria");
      return;
    }

    if (!valor) {
      alert("Insira o valor");
      return;
    }

    if (!descr) {
      alert("Insira a descrição");
      return;
    }

    let fotoParaEnviar = categoriaText !== "Adiantamento" ? foto : `${OPERATIONS_API_BASE}/despesaItem/`;

    if (!fotoParaEnviar && categoriaText !== "Adiantamento") {
      alert("Insira a foto da NF ou Recibo");
      return;
    }

    const url = route.params.id ? `${OPERATIONS_API_BASE}/despesaItem/` + route.params.id : `${OPERATIONS_API_BASE}/despesaItem/`;

    const method = route.params.id ? "PUT" : "POST";

    const requestBody = {
      descr: descr,
      foto: fotoParaEnviar,
      categoria: categoria,
      categoriaText: categoriaText,
      valor: valor,
      iddespesa: despesaId,
    };

    console.log("Enviando dados:", requestBody);

    try {
      const responseApi = await fetch(url, {
        method: method,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const responseData = await responseApi.json();
      console.log("Resposta da API:", responseData);

      if (responseApi.ok) {
        if (typeof route.params.refresh === 'function') {
          route.params.refresh(despesaId);
        } else {
          console.warn('Função de refresh não encontrada.');
        }
        navigation.goBack(null);
      } else {
        throw new Error("Erro ao salvar");
      }
    } catch (error) {
      console.error("Erro ao realizar a requisição:", error);
      alert("Erro ao salvar: " + error.message);
    }
  }

  async function removeImg() {
    const sUrl = `${OPERATIONS_API_BASE}/despesaItem/` + routeId;
    const responseApi = await fetch(sUrl, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        foto: null,
        fotoSeq: fotoSeq + 1
      }),
    });

    const data = await responseApi.json();

    if (responseApi.ok) {
      setFoto(null);
      load();
    } else {
      alert("Erro ao remover imagem: " + data);
    }
  }

  useEffect(() => {
    loadRadio();
    load();
  }, []);

  return (
    <ScrollView style={styles.containerGeral}>

      <Text style={styles.textDescBold}>Categoria: </Text>

      <View style={{ marginTop: 15, width: '94%' }}>
        <RadioForm formHorizontal={false} animation={true} >
          {radio_props.map((obj, i) => (
            <RadioButton labelHorizontal={true} key={i}>
              <RadioButtonInput
                obj={obj}
                index={i}
                isSelected={categoria === i}
                disabled={status > 0}
                onPress={(value) => {
                  setCategoria(value);
                  setCategoriaText(radio_props[value].label);
                }}
                borderWidth={1}
                buttonInnerColor={"#003c84"}
                buttonOuterColor={categoria === 0 ? "#484848" : "#484848"}
                buttonSize={18}
                buttonOuterSize={25}
                buttonStyle={{ padding: 0 }}
                buttonWrapStyle={{ marginLeft: 20, marginTop: 5 }}
              />
              <RadioButtonLabel
                obj={obj}
                index={i}
                labelHorizontal={false}
                disabled={status > 0}
                onPress={(value) => {
                  setCategoria(value);
                  setCategoriaText(radio_props[value].label);
                }}
                labelStyle={{
                  fontSize: 15,
                  color: "#484848",
                  marginLeft: 15,
                }}
                labelWrapStyle={{}}
              />
            </RadioButton>
          ))}
        </RadioForm>
      </View>

      <CurrencyInput
        style={styles.textSearch}
        value={valor}
        onChangeValue={setValor}
        editable={(status < 1 || status == 3)}
        prefix="R$"
        maxLength={200}
        placeholder={"Valor R$"}
        placeholderTextColor="#484848"
        delimiter="."
        separator=","
        precision={2}
        minValue={0}
      />

      <TextInput
        style={styles.textSearch}
        placeholder={"Observação"}
        placeholderTextColor="#484848"
        maxLength={200}
        editable={(status < 1 || status == 3)}
        value={descr}
        onChangeText={setDescr}
        multiline
      />

      {(status < 1 || status == 3) &&
        categoriaText !== "Adiantamento" &&
        <View style={styles.sideContainer}>
          {foto == null &&
            <TouchableHighlight style={{ flex: 1, minWidth: 0 }}
              underlayColor={"transparent"}
              onPress={async () => {
                navigation.navigate("DespesasCamera", { refresh: load, fotoSeq: fotoSeq, refreshFoto: loadFoto });
              }}
            >
              <View style={styles.menuItem}>
                <Text style={styles.textMenu}>Adicionar Foto</Text>
              </View>
            </TouchableHighlight>
          }
          {
            foto != null &&
            <TouchableHighlight style={{ flex: 1, minWidth: 0 }}
              underlayColor={"transparent"}
              onPress={() => {
                removeImg();
              }}
            >
              <View style={styles.menuItem}>
                <Text style={styles.textMenu}>Remover Foto</Text>
              </View>
            </TouchableHighlight>
          }
          <TouchableHighlight style={{ flex: 1, minWidth: 0 }}
            underlayColor={"transparent"}
            onPress={() => {
              save();
            }}
          >
            <View style={styles.menuItem}>
              <Text style={styles.textMenu}>Salvar</Text>
            </View>
          </TouchableHighlight>
        </View>
      }
      {(status < 1 || status == 3) &&
        categoriaText === "Adiantamento" &&
        <View style={styles.sideContainer}>
          {
            foto != null &&
            <TouchableHighlight style={{ flex: 1, minWidth: 0 }}
              underlayColor={"transparent"}
              onPress={() => {
                removeImg();
              }}
            >
              <View style={styles.menuItem}>
                <Text style={styles.textMenu}>Remover Foto</Text>
              </View>
            </TouchableHighlight>
          }
          <TouchableHighlight style={{ flex: 1, minWidth: 0 }}
            underlayColor={"transparent"}
            onPress={() => {
              save();
            }}
          >
            <View style={styles.menuItem}>
              <Text style={styles.textMenu}>Salvar</Text>
            </View>
          </TouchableHighlight>
        </View>
      }
      {foto &&
        <View style={styles.sideContainer2}>
          <Text>Foto atual:</Text>
          <TouchableHighlight
            underlayColor={"transparent"}
            style={{ position: 'absolute', top: 30, left: 10 }}
            onPress={async () => {
              navigation.navigate("DespesasImagem", { foto: foto });
            }}
          >
            <Image style={styles.tinyLogo} source={{ uri: foto }} />
          </TouchableHighlight>

          {(status < 1 || status == 3) &&
            <TouchableHighlight
              underlayColor={"transparent"}
              style={{ position: 'absolute', top: 30, left: 10, backgroundColor: "#000" }}
              onPress={() => {
                removeImg();
              }}
            >
              <Ionicons name="close" color="#900603" size={40} />
            </TouchableHighlight>
          }
        </View>
      }

    </ScrollView>

  );
}

var styles = createScreenStyles({
  container: {
    flex: 1,
    backgroundColor: "#e5e5e5",
  },

  LoadingIndicator: {
    flex: 1,
    justifyContent: "center",
    marginTop: 15,
  },

  sideContainer: {
    flexDirection: "row", gap: 12,
  },

  tinyLogo: {
    height: 180,
    width: 150,
    borderRadius: 10
  },

  sideContainer2: {
    marginTop: 20,
    height: 280
  },

  menuItem: {
    width: '100%',
    height: screenHeight * 0.1,
    marginTop: 10,
    marginRight: 0,
    backgroundColor: "#296D98",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 6,
    },
    shadowOpacity: 0.37,
    shadowRadius: 7.49,
    elevation: 12,
  },

  textMenu: {
    color: "#fff",
    fontSize: 16,
  },

  textSearch: {
    width: '94%',
    paddingLeft: 10,
    color: "#484848",
    height: 50,
    marginTop: screenHeight * 0.01,
    backgroundColor: "#fff",
    borderColor: "#A1A1A1",
    borderWidth: 1,
    borderRadius: 5,
  },

  textEmpty: {
    fontSize: 14,
    fontWeight: "300",
    color: "#484848",
    marginLeft: screenWidth * 0.025,
    marginTop: 10,
    textAlign: "center",
  },

  textDesc: {
    fontSize: 14,
    paddingTop: 5,
  },

  textDescBold: {
    fontSize: 14,
    paddingTop: 5,
    fontWeight: "bold",
  },

  textDescBold2: {
    fontSize: 16,
    marginBottom: 10,
    marginTop: 10,
    fontWeight: "bold",
    textAlign: "center",
  },

  textDescAberto: {
    fontSize: 12,
    paddingTop: 5,
    color: "green",
  },

  containerGeral: {
    flex: 1,
    backgroundColor: "#fff",
    paddingLeft: 10,
    paddingBottom: 10,
    borderRadius: 3,
  },

  txtContainer: {
    width: '95%',
    marginTop: 5,
  },

  highlight: {
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
  },

  buttonDone: {
    backgroundColor: "#336633",
    marginTop: 5,
    height: 30,
    width: '90%',
    justifyContent: "center",
  },

  buttonPend: {
    backgroundColor: "#993333",
    marginTop: 5,
    height: 30,
    width: '90%',
    justifyContent: "center",
  },

  buttonText: {
    textAlign: "center",
    color: "#fff",
  },
});
